import { render, staticRenderFns } from "./InformasiKlaimDirektur.vue?vue&type=template&id=5979437a&"
import script from "./InformasiKlaimDirektur.vue?vue&type=script&lang=js&"
export * from "./InformasiKlaimDirektur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports